var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L16 10M16 10L10 16M16 10V23.8C16 25.8861 16 26.9291 16.8258 28.0969C17.3744 28.8728 18.9541 29.8305 19.8958 29.9581C21.3132 30.1501 21.8514 29.8693 22.9279 29.3078C27.725 26.8054 31 21.7851 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 21.5521 4.01649 26.3997 8.5 28.9933",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProgress);
export default __webpack_public_path__ + "static/media/uploadProgress.26a3d9b1c88dfa32c6ab4d6fae2781e9.svg";
export { ForwardRef as ReactComponent };